module.exports = __webpack_public_path__ + "media/images/media-elements/mute-cedcfea9df8403153e120cf505fa75cb.svg";